export default __webpack_public_path__ + "logo.d4af72722525be62b64285d305326d1f.svg";